import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "ProductFavorite" })
export default class ProductFavorite extends Vue {
    public localizer: any = Localizer;
    public productFavoritesList: any[] = [];
    public isLoading: boolean = true;

    @Prop() readonly productType: string;
    @Prop() readonly productBremboCode: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getFavoritesList();
    }

    public async removeFromFavourites(referenceCode: string) {
        const response = (await Axios.post(this.routes.ProfileFavorite_FavoriteRemove, { referenceCode: referenceCode })).data;

        if (response) {
            await this.getFavoritesList();
        }
    }

    public async addToFavourites(params: any) {
        const response = (await Axios.post(this.routes.ProfileFavorite_FavoriteAdd, params)).data;

        GTagHelper.sendCustomEvent("click", { favourite_product_type: this.productType });

        if (response) {
            await this.getFavoritesList();
        }
    }

    public async getFavoritesList() {
        this.isLoading = true;

        const response = (await Axios.post(this.routes.ProfileFavorite_GetFavoriteList, null)).data;

        if (response.favorites) {
            this.productFavoritesList = response.favorites;
        }
        this.isLoading = false;
    }

    public async toggleAddProductToFavourites() {
        var params = {
            favoriteType: "Product",
            referenceType: this.productType,
            referenceCode: this.productBremboCode
        };

        const response = (await Axios.post(this.routes.ProfileFavorite_IsFavorite, { referenceCode: this.productBremboCode })).data;

        if (response.success) {
            await this.removeFromFavourites(this.productBremboCode);
        } else {
            await this.addToFavourites(params);
        }
    }
}